
import React from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const NoReportsFound: React.FC = () => {
  return (
    <div className="text-center py-8">
      <FileText className="h-12 w-12 mx-auto text-gray-300 mb-3" />
      <p className="text-gray-500">ยังไม่มีรายงานที่บันทึกไว้</p>
      <Link to="/form">
        <Button className="mt-4 bg-form-blue hover:bg-form-light-blue">
          สร้างรายงานใหม่
        </Button>
      </Link>
    </div>
  );
};
